import { TERMOS } from '../../lib/glossario'

/**
 * Os termos das ordens de serviço, agora no glossário.
 *
 * **Cada entrada soletra `TERMOS.<chave>.rotulo` e `TERMOS.<chave>.ajuda`, em vez de apontar para o
 * objeto inteiro.** Não é verbosidade: `lib/ajudaExibida.test.ts` varre o código-fonte atrás de
 * quem exibe cada explicação, e uma referência indireta some da varredura — o teste passaria a
 * dizer que estas sete ajudas nunca chegam à tela, quando elas chegam, por `<Explicacao>`, nas
 * cinco telas abaixo. Soletrar aqui é o que mantém o guarda funcionando, e de quebra deixa
 * escrito quais explicações este módulo é responsável por exibir.
 */
export const TERMOS_DA_OS = {
  /** Título da lista de ordens. */
  ordemDeServico: { rotulo: TERMOS.ordemDeServico.rotulo, ajuda: TERMOS.ordemDeServico.ajuda },
  /** Identificação: o modelo IA ou IB. */
  regimeDaOs: { rotulo: TERMOS.regimeDaOs.rotulo, ajuda: TERMOS.regimeDaOs.ajuda },
  /** Cartão de prazos: o marco de que o contrato conta (6.24.6, p.45). */
  entregaAoPreposto: { rotulo: TERMOS.entregaAoPreposto.rotulo, ajuda: TERMOS.entregaAoPreposto.ajuda },
  /** Cartão de prazos: o documento que o TR cita e não modela. */
  termoDeEncerramentoDaOs: {
    rotulo: TERMOS.termoDeEncerramentoDaOs.rotulo,
    ajuda: TERMOS.termoDeEncerramentoDaOs.ajuda,
  },
  /** Quadro de itens e linha do formulário: a fração 25/30 do mês parcial. */
  quantidadeComoFracao: {
    rotulo: TERMOS.quantidadeComoFracao.rotulo,
    ajuda: TERMOS.quantidadeComoFracao.ajuda,
  },
  /** Nota da seção 6 do ANEXO IB, cuja natureza o TR não define. */
  divisaoDaOs: { rotulo: TERMOS.divisaoDaOs.rotulo, ajuda: TERMOS.divisaoDaOs.ajuda },
  /** Identificação: o papel que assina e que o TR não inclui na equipe de fiscalização. */
  fiscalRequisitante: { rotulo: TERMOS.fiscalRequisitante.rotulo, ajuda: TERMOS.fiscalRequisitante.ajuda },
} as const
